<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div class="panel border-[#e0e6ed] px-5 dark:border-[#1b2e4b]">
  <div class="mb-4.5 flex flex-col gap-5 md:flex-row md:items-center">
    <a class="btn btn-primary cursor-pointer gap-2" (click)="openCreateModal()"> <icon-plus /> {{ "qna.create" | translate }} </a>
  </div>
  <p class="italic text-sm">*{{ "qna.change_order_info" | translate }}</p>
  <div class="mb-5 mt-3 flex flex-wrap justify-between border-b border-white-light dark:border-[#191e3a] print:hidden">
    <div class="flex flex-wrap">
      <a
        href="javascript:;"
        class="-mb-[1px] flex items-center border-transparent p-5 py-3 !outline-none transition duration-300 hover:border-b hover:!border-secondary hover:text-secondary"
        [ngClass]="{
          'border-b-2 border-secondary text-secondary': language === 'sr',
          'tab-active': language === 'sr',
          'hover:border-b hover:border-secondary hover:text-secondary': language === 'sr',
        }"
        (click)="language = 'sr'"
      >
        {{ "srp" | translate }}
      </a>
      <a
        href="javascript:;"
        class="-mb-[1px] flex items-center border-transparent p-5 py-3 !outline-none transition duration-300 hover:border-b hover:!border-secondary hover:text-secondary"
        [ngClass]="{
          'border-b-2 border-secondary text-secondary': language === 'en',
          'tab-active': language === 'en',
          'hover:border-b hover:border-secondary hover:text-secondary': language !== 'en',
        }"
        (click)="language = 'en'"
      >
        {{ "eng" | translate }}
      </a>
    </div>
  </div>
  <div [sortablejs]="questions" [sortablejsOptions]="sortableOptions">
    <div *ngFor="let question of questions; let i = index">
      <div class="bg-white-light/30 shadow-md dark:border-[#3b3f5c] p-3 rounded-md mt-3 cursor-grab">
        <div class="flex items-center justify-between">
          <p class="text-2xl">{{ i + 1 }}. {{ language === "sr" ? question.questionSR : question.questionEN }}</p>
          <div class="flex items-center">
            <button
              type="button"
              class="flex items-center px-4 py-2 text-white-dark focus:outline-none dark:bg-[#1b2e4b]"
              [ngClass]="{ '!text-primary': accordians[question.id] }"
              (click)="toggleAccordion(question.id)"
            >
              {{ "qna.answer" | translate }}
              <div class="ltr:ml-auto rtl:mr-auto" [ngClass]="{ 'rotate-180': accordians[question.id] }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4">
                  <path d="M19 9L12 15L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </button>
            <a (click)="openCreateModal(question.id)" class="btn btn-primary cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto mr-2">
              <icon-pencil-paper />
            </a>
            <a (click)="openDeleteModal(question.id)" class="btn btn-primary cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto">
              <icon-trash />
            </a>
          </div>
        </div>
        <div>
          <div [@slideDownUp]="!accordians[question.id]" class="accordion-content">
            <div class="space-y-2 p-4 text-base">
              <p>{{ language === "sr" ? question.answerSR : question.answerEN }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addQuestionModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "qna.create" | translate }}</div>
    <app-qna-form [questionId]="questionToEditId" (closeForm)="closeCreateModal()"></app-qna-form>
  </div>
</ng-template>